export enum Order {
  Ascending = 'ASC',
  Descending = 'DESC',
}

export enum SortByTable {
  LoanApplication = 'LoanApplication',
  Person = 'Person',
  Customer = 'Customer',
  LoanApplicationSummary = 'LoanApplicationSummary',
  Lock = 'Lock',
  Assignment = 'Assignment',
}

export interface SortBy {
  Table: SortByTable;
  Column: string;
}

export interface FindSort {
  SortBy: SortBy;
  Order: Order;
}
